// extracted by mini-css-extract-plugin
export default {"navigation-link":"NavigationLink_navigation-link__+TUin"};